import { HttpClient } from '#client/http/index'
import { SitemapResponse } from '#client/resources/index'

export const get = async ({
  httpClient,
}: {
  httpClient: HttpClient
}): Promise<SitemapResponse> => {
  return await httpClient.get(`/user/sitemap`)
}
